export const PERMS = {
    READ: 'transport_types.read',
    UPDATE: 'transport_types.update',
    DELETE: 'transport_types.delete',
    CREATE: 'transport_types.create',
    EXPORT: 'transport_types.export',
}
